import { useDispatch } from "react-redux";
import { shootToast } from "codekit";

import { useNavigateProcess } from "../../utils/hooks/useNavigateProcess";
import { setFunctionToExecute } from "../../libs/redux/slices/trackingSlice/trackingSlice";

/**
 * Drill-down único del kit de tableros: todo número lleva al tracking del
 * proceso con la consulta inducida (useNavigateProcess + filtros), o abre
 * un DO directo. Si el usuario no tiene el proceso en su menú, avisa.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 */
export function useDrilldown() {
  const dispatch = useDispatch();
  const { handleNavigateProcess } = useNavigateProcess();

  /** Filtro inducido "columna IN valores" del tracking genérico */
  const filtroIn = (columna, valores) => ({ [columna]: { IN: (Array.isArray(valores) ? valores : [valores]).map(String) } });

  /** Abre el tracking del proceso con los filtros inducidos */
  const ir = (modulo, proceso, filtros = []) => {
    const bNavego = handleNavigateProcess(modulo, proceso, filtros);
    if (!bNavego) {
      shootToast({ variant: "info", text: "No tiene esa pantalla en su menú", duration: 3000, autoHide: true });
    }
    return bNavego;
  };

  /** Abre directo la ficha del DO de importación (flujo External de Trackimp) */
  const abrirDo = (docnroxx) => {
    const filtros = [filtroIn("MDOSYYYY.DOCNROXX", docnroxx)];
    dispatch(setFunctionToExecute({ execute: true, functionName: "handleToggleEdit", ciacidxx: filtros, selector: {} }));
    return ir("Modimpxx", "Trackimp", filtros);
  };

  return { ir, filtroIn, abrirDo };
}

export default useDrilldown;
